import { AfterViewInit, Component, DestroyRef, EventEmitter, Input, Output } from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CrossSellProductsComponent } from '@scalefast/components/product';
import { Product } from '@scalefast/core';
import { CrossSellProductsService } from '@scalefast/ecommerce-core';
import { AppCrossSellProductsTemplateComponent } from './cross-sell-products-template/cross-sell-products-template.component';

@Component({
  imports: [CrossSellProductsComponent, AppCrossSellProductsTemplateComponent],
  standalone: true,
  selector: 'app-cross-sell-products',
  template: `<app-cross-sell-products-template
    [crossSellProducts]="crossSellProducts"
    (addCrossSellProductToCartEvent)="addCrossSellProductToCart($event)"
  />`,
})
export class AppCrossSellProductsComponent implements AfterViewInit {
  @Input() product: Product | undefined;
  @Output() addCrossSellProductToCartEventHandler = new EventEmitter<Product>();
  crossSellProducts: Product[] = [];

  constructor(
    private destroyRef: DestroyRef,
    private crossSellProductsService: CrossSellProductsService,
  ) {}

  ngAfterViewInit(): void {
    this.getCrossSellProducts();
  }

  getCrossSellProducts(): void {
    this.crossSellProductsService
      .getCrossSellProducts(this.product)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((crossSellProducts) => {
        this.crossSellProducts = crossSellProducts;
      });
  }

  addCrossSellProductToCart(crossSellProduct: Product): void {
    this.addCrossSellProductToCartEventHandler.emit(crossSellProduct);

    // Refresh the cross sell related products
    this.product = crossSellProduct;
    this.getCrossSellProducts();
  }
}
